import { render, staticRenderFns } from "./NavItemNaf.vue?vue&type=template&id=849ef03a"
import script from "./NavItemNaf.vue?vue&type=script&lang=js"
export * from "./NavItemNaf.vue?vue&type=script&lang=js"
import style0 from "./NavItemNaf.vue?vue&type=style&index=0&id=849ef03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports